import { useEffect } from 'react';

const APP_STORE_URL = 'https://apps.apple.com/us/app/prepwize-calorie-tracker/id6744729394';

function GetApp() {
  useEffect(() => {
    window.location.replace(APP_STORE_URL);
  }, []);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <p>Redirecting to the App Store…</p>
    </div>
  );
}

export default GetApp;
